/* eslint-disable no-console */
declare const window: { loggerEnabled: boolean };

class Logger {
    constructor() {
        window.loggerEnabled = !(process.env.NODE_ENV === 'production');
    }

    log (...output: string[] | Record<string, unknown>[]): void {
        if (!window.loggerEnabled) {
            return;
        }

        console.log(...output);
    }

    warn (...output: string[]): void {
        if (!window.loggerEnabled) {
            return;
        }

        console.warn(...output);
    }

    error (...output: string[]): void {
        if (!window.loggerEnabled) {
            return;
        }

        console.error(...output);
    }
}
  
const logger = new Logger();

export {logger};
